export enum LocalStorageKey {
  Session = 'Session',
  Collapsable = 'collapse',
  SessionExpiry = 'SessionExpiry'
}
